/**
 * Batch Processes Shared Store
 */

import { createStore } from '@commandDrivenStateEngine/core/createStore';
import { Policy } from '@commandDrivenStateEngine/core/policies';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { initialState, BatchProcessesSharedState } from './state';
import { handlers } from './handlers';
import { invariants } from './invariants';
import { BatchProcessesSharedCommand } from './commands';
import { createActiveProcessesSubscriptionPolicy } from './policies/activeProcessesSubscriptionPolicy';
import { createActiveProgressSubscriptionPolicy } from './policies/activeProgressSubscriptionPolicy';
import { createRevokedActiveChannelTargetsPolicy } from './policies/revokedActiveChannelTargetsPolicy';

export { selectors } from './state';

const store = createStore({
  name: 'batch-processes-shared',
  initialState,
  handlers,
  invariants
});

export const {
  useSelector: useBatchProcessesSharedSelector,
  useErrors: useBatchProcessesSharedErrors,
  useDispatch: useBatchProcessesSharedDispatch,
  usePolicies: useBatchProcessesSharedPolicies,
  getState: getBatchProcessesSharedState,
  dispatch: dispatchBatchProcessesSharedCommand
} = store;

/**
 * Policy factory - creates policies for the shared batch processes store.
 */
export const createBatchProcessesSharedPolicies = (
  backend: ClientLibraryType
): Policy<BatchProcessesSharedState, BatchProcessesSharedCommand>[] => [
  createActiveProcessesSubscriptionPolicy( backend ),
  createActiveProgressSubscriptionPolicy( backend ),
  createRevokedActiveChannelTargetsPolicy(( integrationId ) => backend.queries.ExternalSystemsIntegrationsById( integrationId ))
];
